if (!customElements.get('unity-cart-related')) {
 customElements.define('unity-cart-related',class extends HTMLElement {
  connectedCallback(){
   this.refresh=this.refresh.bind(this);
   this.observer=new MutationObserver(()=>{clearTimeout(this.timer);this.timer=setTimeout(this.refresh,120);});
   const root=document.getElementById('main-cart-items');
   if(root)this.observer.observe(root,{childList:true,subtree:true});
   this.refresh();
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();clearTimeout(this.timer);}
  async refresh(){
   const ids=[...document.querySelectorAll('#main-cart-items [data-unity-cart-product]')].map(el=>el.dataset.unityCartProduct);
   const key=ids.join(',');
   if(this.key===key)return;
   this.key=key;this.controller?.abort();this.hidden=true;
   if(!ids.length)return;
   this.controller=new AbortController();
   const url=new URL(this.dataset.url,location.origin);
   url.searchParams.set('section_id',this.dataset.sectionId);
   url.searchParams.set('product_id',ids[0]);
   url.searchParams.set('limit','10');
   url.searchParams.set('intent','related');
   try{
    const res=await fetch(url,{signal:this.controller.signal});
    if(!res.ok)return;
    const doc=new DOMParser().parseFromString(await res.text(),'text/html');
    if(this.key!==key)return;
    const content=doc.querySelector('[data-cart-related-content]');
    if(!content)return;
    let count=0;
    content.querySelectorAll('[data-related-product]').forEach(card=>{
      if(ids.includes(card.dataset.relatedProduct)||count>=2)card.remove();else count++;
    });
    if(!count)return;
    this.querySelector('[data-cart-related-content]').replaceChildren(...content.childNodes);
    this.hidden=false;
   }catch(error){if(error.name!=='AbortError')this.hidden=true;}
  }
 });
}